<template>
    <div class="background">
        <div class="login">
            <div class="img-container">
                <picture>
                    <source media="(orientation: landscape)" srcset="static/icons/taa-horizontal-colorida.svg">
                    <img src="static/icons/taa_logo.png" alt="TAA Logo">
                </picture>
            </div>
            <template v-if="!isOracle() || !showServerIpInput">
                <div class="inputs">
                    <div class="usuario">
                        <p> {{ getString('usuario') }} <span class="asterisco">*</span></p>
                        <div id="loginName" ref="loginNameDiv" class="div-input-android upper-layer"
                            :class="{'active-input': isTheActiveInput('loginNameDiv')}"
                            @click="switchActiveInput('loginNameDiv')">
                        </div>
                    </div>
                    <div class="senha">
                        <p> {{ getString('senha') }} <span class="asterisco">*</span></p>
                        <div id="loginPassword" ref="loginPasswordDiv" class="div-input-android upper-layer"
                            :class="{'active-input': isTheActiveInput('loginPasswordDiv')}"
                            @click="switchActiveInput('loginPasswordDiv')">
                        </div>
                    </div>
                </div>
                <div class="botao">
                    <button @click="login()" v-text="getString('entrar')" class="upper-layer"></button>
                    <button @click="goBack()" v-text="getString('cancelar')" class="upper-layer"></button>
                    <div class="server-ip-config" v-if="isOracle()" @click="toggleInterfaceAddressInput()" v-text="getString('interface_address')"></div>
                </div>
                <div class="params" v-if="generalParams">
                        <p v-text="getString('version') + ` ${version}`"></p>
                        <p>Filial: {{ generalParams.subsidiaryCode || 'Não informado' }}</p>
                        <p>Loja: {{ generalParams.storeCode || 'Não informado' }}</p>
                        <p>Caixa: {{ generalParams.posCode || 'Não informado' }} {{ generalParams.posName }}</p>
                        <p>ID do terminal: {{ generalParams.clientId || 'Não informado' }}</p>
                    </div>
            </template>

            <template v-else>
                <div class="server-ip-input">
                    <p> {{ getString('interface_address') + ':' }} <span class="asterisco">*</span></p>
                    <div id="interfaceAddress" ref="interfaceAddressDiv" class="div-input-android upper-layer"
                        :class="{'active-input': isTheActiveInput('interfaceAddressDiv')}"
                        @click="switchActiveInput('interfaceAddressDiv')">
                    </div>
                </div>
                <div class="server-ip-input" v-if="false">
                    <p> {{ getString('apache') }} <span class="asterisco">*</span></p>
                    <div id="apacheAddress" ref="apacheAddressDiv" class="div-input-android upper-layer"
                        :class="{'active-input': isTheActiveInput('apacheAddressDiv')}"
                        @click="switchActiveInput('apacheAddressDiv')">
                    </div>
                </div>
                <div class="botao">
                    <button @click="applyInterfaceAddress()" v-text="getString('aplicar')" class="upper-layer"></button>
                    <button @click="toggleInterfaceAddressInput()" v-text="getString('cancelar')" class="upper-layer"></button>
                </div>
            </template>

            <div class="keyboard-overlay" v-if="visible" @click="closeKeyboard"></div>
        </div>

        <AndroidKeyboard id="android-keyboard" v-if="visible"
            :inputElement="inputElement"
            :layout="layout"
            :isPasswordField="isPasswordField"
            :handlleClipboard="true"
            @passwordCharacterTyped="passwordCharacterTyped"
            @passwordCharacterErased="passwordCharacterErased"
            @passwordFieldCleaned="passwordFieldCleaned">
        </AndroidKeyboard>
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import LocaleController from '@/assets/controllers/LocaleController'
import AccessController from '@/assets/controllers/AccessController'
import requestModule from '@/assets/libs/requestModule'
import WebsocketController from '@/assets/controllers/WebsocketController'
import axios from 'axios'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'

export default {
    name: 'Login',
    components: {
        AndroidKeyboard
    },
    data () {
        return {
            version: process.env.VERSION,
            visible: false,
            layout: keyboardLayout.LOGIN_AND_PASSWORD,
            inputElement: null,
            isPasswordField: false,
            loginName: '',
            password: '',
            ip: '',
            btnApply: {
                text: this.getString('aplicar'),
                status: true
            },
            showServerIpInput: false,
            interfaceAddress: '',
            apacheAddress: '',
            generalParams: Util.getGeneralInfo()
        }
    },
    mounted () {
        if (!(this.$route && this.$route.params && this.$route.params.allowed === true) && process.env.NODE_ENV === 'production') {
            this.$router.push({
                name: 'WaitScreen'
            })
        }

        this.inputElement = this.$refs.loginNameDiv
        if (Util.isOracle() && !Util.getLocalConfigs('urlOdhenInterface')) {
            this.inputElement = this.$refs.interfaceAddressDiv
            this.showServerIpInput = true
            this.interfaceAddress = this.getServer().interfaceAddress
            setTimeout(() => {
                this.$refs.interfaceAddressDiv.innerText = this.interfaceAddress
            }, 200)
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        isTheActiveInput: function (divReference) {
            return this.inputElement === this.$refs[divReference]
        },
        switchActiveInput: function (divReference) {
            this.inputElement = this.$refs[divReference]
            this.isPasswordField = this.inputElement === this.$refs.loginPasswordDiv
            this.visible = true
        },
        passwordCharacterTyped: function (key) {
            this.password += key
        },
        passwordCharacterErased: function () {
            this.password = this.password.slice(0, -1)
        },
        passwordFieldCleaned: function () {
            this.password = ''
        },
        closeKeyboard: function () {
            this.visible = false
        },
        goBack: function () {
            if (!WebsocketController.isTerminalAvailable() && !Util.isOracle()) {
                this.$router.push('/maintenance')
                return
            }
            this.$router.push('/')
        },
        login: async function () {
            this.loginName = this.$refs.loginNameDiv.innerText
            this.closeKeyboard()
            await requestModule.postRequest('login', { user: this.loginName, password: this.password })
                .then(res => {
                    let isValidResponse = res && !res.error && res.data && res.data.length > 0

                    if (isValidResponse) {
                        if (AccessController.hasFilledPermissions(res.data[0])) {
                            if (AccessController.hasAnyPermission(res.data[0])) {
                                AccessController.setPermissions(res.data[0])
                                this.$router.push({
                                    name: 'Config',
                                    params: {
                                        'firstLoad': true
                                    }
                                })
                            } else {
                                Util.showErrorNotification({ title: this.getString('nao_possui_acesso_suficiente'), text: null })
                            }
                        } else {
                            Util.showInfoModal(LocaleController.getString('permissoes_nao_cadastradas'))
                        }
                    } else {
                        let message = (res && res.message !== '' && res.message != null) ? res.message : 'O login falhou'
                        if (res && res.code && res.code === 'ERR_INVALID_ARG_TYPE') {
                            message = this.getString('verificar_conexao')
                        }
                        throw new Error(message)
                    }
                }).catch((e) => {
                    console.error(e)
                    Util.showErrorNotification({ title: e, text: null })
                })
        },
        isOracle: function () {
            return Util.isOracle()
        },
        getServer: function () {
            // return Util.getLocalConfigs('enderecoInterface') || ''
            return {
                'interfaceAddress': Util.getLocalConfigs('urlOdhenInterface') || process.env.ORACLE_INTERFACE_ADDRESS || ''
            }
        },
        testInterfaceAddress: async function () {
            let testInterface = await axios({
                method: 'get',
                url: this.interfaceAddress,
                responseType: 'json'
            }).then(r => r && r.data)
                .catch((e) => {
                    return {
                        error: true,
                        message: e
                    }
                })
            if (!testInterface || testInterface.error) {
                return false
            }
            testInterface = testInterface.data
            if (!testInterface.connection) {
                let errorMessage = 'Interface encontrada mas não possue conexão com banco de dados'
                Util.showErrorNotification(errorMessage)
                return false
            }
            if (testInterface.version) {
                const minVersionSupported = process.env.minVersionSupported
                let interfaceVersionIsSupported = Util.interfaceVersionIsSupported(testInterface.version, minVersionSupported)
                if (interfaceVersionIsSupported) {
                    return true
                } else {
                    let errorMessage = this.getString('versao_interface') + `(${testInterface.version})` +
                    this.getString('incompativel_com_o_TAA_necessario_versao') + minVersionSupported +
                    this.getString('ou_superior')
                    Util.showErrorNotification(errorMessage)
                }
            }
            return false
        },
        applyInterfaceAddress: async function () {
            this.interfaceAddress = this.$refs.interfaceAddressDiv.innerText
            let testInterface = await this.testInterfaceAddress()
            if (!testInterface) {
                Util.showErrorNotification('Odhen-Interface não encontrada')
                return false
            }
            let config = Util.getLocalVar('taaconfig') || null
            if (!config) {
                config = Util.createInitialConfig()
            }
            config.urlOdhenInterface = this.interfaceAddress
            Util.setLocalVar('taaconfig', config)
            Util.reloadcachedConfigs()
            this.toggleInterfaceAddressInput()
        },
        toggleInterfaceAddressInput: async function () {
            this.showServerIpInput = !this.showServerIpInput
            let sf = this
            if (this.showServerIpInput) {
                setTimeout(() => {
                    sf.$refs.interfaceAddressDiv.innerText = sf.interfaceAddress
                }, 200)
            } else {
                setTimeout(() => {
                    sf.switchActiveInput('loginNameDiv')
                    sf.$refs.loginNameDiv.innerText = ''
                    sf.$refs.loginPasswordDiv.innerText = ''
                }, 200)
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
    @import (reference) url("../assets/common.less");

    .background {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: lightgray;
    }

    .login {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: relative;
        width: 80%;
        height: 80%;

        .div-input-android {
            position: relative;
            display: flex;
            align-items: center;
            font-size: 2rem;
            height: 55px;
            background-color: white;
            color: black;
            border: 2px solid @black;
            padding: 0 20px;
            overflow-x: auto;
            overflow-y: hidden;
            white-space: nowrap;
        }
        .div-input-android::-webkit-scrollbar {
            height: 5px;
        }

        .active-input {
            border: 3px solid @primary-color;
        }

        .upper-layer {
            z-index: 4;
        }

        .keyboard-overlay {
            z-index: 2;
            position: absolute;
            width: 130vw;
            height: 100vh;
            top: -51%;
            left: -50%;
        }
    }

    #android-keyboard {
        .keyboard;
        bottom: 60px;
        margin: 0;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }

    input {
        font-size: 1.7rem;
        padding-left: 10px;
    }

    .img-container {
        max-width: 100%;
        height: 30vh;
        display: block;
        position: relative;

        img {
            display: block;
            width: 100%;
            height: 100%;
            position: relative;
            object-fit: contain;
        }
    }

    p {
        font-size: 1.7rem;
    }

    .usuario input, .senha input {
        height: 3.4rem;
        margin-bottom: 1rem;
        border: 1px solid @disabled-color;
        width: 99%;
        margin: 0;
        display: inline-block;
        padding: 5px;
    }

    .senha input {
        margin-bottom: 40px;
    }

    .botao {
        margin-top: 60px;
    }

    .params {
        color: rgb(53, 53, 53);
        padding-top: 50px;
        p {
            margin: 5px 0;
        }
    }

    .botao button {
        position: relative;
        background-color: @primary-dark;
        color: @white;
        border: none;
        width: 100.5%;
        padding: 20px;
        margin: 0;
        font-size: 1.5rem;
        font-weight: bold;
        &:last-of-type{
            margin-top: 15px;
            background-color: @primary-light;
        }
    }
    .botao button.disabled {
        pointer-events: none;
        touch-action: none;
        background-color: rgb(201, 201, 201);
    }

    .botao .server-ip-config {
        color: blue;
        text-align: center;
        font-size: 30px;
        margin: 25px 0;
    }

    #keyboard {
        .keyboard;
        bottom: 60px;
    }

    .asterisco {
        color: @primary-color;
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        img {
            margin-top: -70px;
            margin-bottom: -180px;
        }

        #keyboard {
            .keyboard;
            max-width: 760px;
            font-size: 20px;
        }
        .params {
            color: rgb(53, 53, 53);
            padding-top: 10px;
            p {
                margin: 2px 0;
            }
        }
        .botao .server-ip-config {
            color: blue;
            text-align: center;
            font-size: 30px;
            margin: 25px 0;
        }
        .div-input-android {
            font-size: 25px;
            height: 35px;
            border: 1px solid @black;
            padding: 0 10px;
        }
    }

    @media (max-width: 698px) { // Gertec SK210
        .login {
            width: 70%;
            height: 90%;

            .div-input-android {
                font-size: 18px;
                height: 35px;
                border: 1px solid @black;
                padding: 0 10px;
            }

            .active-input {
                border: 2px solid @primary-color;
            }
        }

        #android-keyboard {
            .small-screen-keyboard;
            width: 100%;
            max-width: 100%;
            bottom: 30px;
            box-shadow: 0px 0px 2px rgb(0 0 0%);
        }

        .img-container {
            height: 25vh;
        }

        p {
            font-size: 20px;
        }

        .botao {
            margin-top: 30px;
        }
        .params {
            color: rgb(53, 53, 53);
            padding-top: 5px;
            p {
                margin: 2px 0;
            }
        }
        .botao button {
            padding: 12px;
            font-size: 18px;
        }
        .botao .server-ip-config {
            color: blue;
            text-align: center;
            font-size: 18px;
            margin: 15px 0;
        }
    }

    @media (orientation: landscape) and (min-height: 800px) {
        .img-container {
            max-width: 100%;
            height: 30vh;
            display: block;
            position: relative;
        }
        .params {
            color: rgb(53, 53, 53);
            padding-top: 10px;
            p {
                margin: 2px 0;
            }
        }
        .botao .server-ip-config {
            color: blue;
            text-align: center;
            font-size: 30px;
            margin: 25px 0;
        }
        .login {
            height: auto;
            .div-input-android {
                font-size: 30px;
                height: 40px;
                border: 1px solid @black;
                padding: 0 10px;
            }
            .active-input {
                border: 2px solid @primary-color;
            }
        }
        p {
            margin: 15px 0;
            font-size: 23px
        }
        .botao {
            margin-top: 0;
            margin: 30px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            button {
                margin: 0 !important;
                width: 45%;
            }
        }

        #android-keyboard {
            .keyboard;
            bottom: 30px;
        }
    }
    @media (orientation: landscape) {
        .img-container {
            max-width: 100%;
            height: 22vh;
            display: block;
            position: relative;
        }
        .params {
            padding-top: 5px;
            p {
                margin: 2px 0;
            }
        }
        .botao .server-ip-config {
            color: blue;
            text-align: center;
            font-size: 30px;
            margin: 25px 0;
        }
        .login {
            height: auto;
            .inputs {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                gap: 10px;
                .usuario {
                    width: 48%;
                }
                .senha {
                    width: 48%;
                }
                .div-input-android {
                    font-size: 30px;
                    height: 40px;
                    border: 1px solid @black;
                    padding: 0 10px;
                }
                .active-input {
                    border: 2px solid @primary-color;
                }
            }
        }
        p {
            margin: 15px 0;
            font-size: 23px
        }
        .botao {
            margin-top: 0;
            margin: 30px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            button {
                margin: 0 !important;
                width: 48%;
            }
        }

        #android-keyboard {
            .keyboard;
            bottom: 30px;
            max-width: unset;
            font-size: 1rem;
            padding: 5px 10px !important;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/Login.vue